// core components
import { Card, CardBody, CardText, CardTitle } from "reactstrap";

const StepCard = ({ id, title, paragraph, bold, paragraph1, isLast }) => {
    return (
        <div className="d-flex gap-3 position-relative">
            <div className="d-flex flex-column align-items-center">
                <div
                    className="rounded-circle bg-orange-400 text-white fw-bold d-flex align-items-center justify-content-center"
                    style={{ width: "40px", height: "40px", zIndex: 1 }}
                >
                    {id}
                </div>
                {!isLast && <div style={{ width: "4px", backgroundColor: "#F26522", flexGrow: 1 }}></div>}
            </div>
            <div>
                <Card className="bg-transparent">
                    <CardBody className="p-0">
                        <CardTitle className="fw-semibold">{title}</CardTitle>
                        <CardText>{paragraph}{bold && <b>{bold}</b>} {paragraph1}</CardText>
                    </CardBody>
                </Card>
            </div>
        </div>
    );
}

export default StepCard;
